// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bwxze","footer":"styles_footer__2RaQi","passCodeTooltip":"styles_passCodeTooltip__15XPo"};